// UI shell variants only — not URL segments. Route matching lives in statusLoadingRoute via Page.
export enum NewStatusPageLoadingPanel {
  AllFields = 'AllFields',
  FieldDetails = 'FieldDetails',
}
